import React from "react";
import { makeStyles } from "@material-ui/core";
import { RB_PAY_SETUP_COLORS } from "../constants/rbPaySettings.constants";
import { RBPaySetupTheme } from "../utils/rbPaySettings.theme";

const C = RB_PAY_SETUP_COLORS;

const useStyles = makeStyles({
  card: {
    display: "flex",
    gap: "12px",
    padding: "13px 16px",
    borderRadius: 8,
    cursor: "pointer",
    userSelect: "none",
    flex: 1,
    transition: "border-color 0.1s, background 0.1s",
  },
  radio: {
    width: 18,
    height: 18,
    minWidth: 18,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginTop: 1,
  },
  radioDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#fff",
  },
  title: {
    fontSize: 14,
    margin: 0,
  },
  description: {
    fontSize: 12,
    color: C.textMuted,
    margin: "3px 0 0",
    lineHeight: 1.45,
  },
  group: {
    display: "flex",
    gap: "12px",
  },
  errorText: {
    minHeight: 20,
    color: C.errorText,
    fontSize: 12.5,
    marginTop: 6,
  },
});

interface RBPayChoiceCardProps {
  title: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onSelect: () => void;
  theme: RBPaySetupTheme;
}

export const RBPayChoiceCard: React.FC<RBPayChoiceCardProps> = ({
  title,
  description,
  checked,
  disabled,
  onSelect,
  theme,
}) => {
  const classes = useStyles();

  const cardStyle: React.CSSProperties = checked
    ? { border: `2px solid ${theme.secondary}`, background: theme.secondarySoft }
    : { border: `1.5px solid ${C.optionOffBorder}`, background: C.optionOffBg };
  const radioStyle: React.CSSProperties = checked
    ? { border: `2px solid ${theme.secondary}`, background: theme.secondary }
    : { border: `2px solid ${C.radioOffBorder}`, background: "#fff" };
  const titleStyle: React.CSSProperties = checked
    ? { fontWeight: 600, color: theme.secondary }
    : { fontWeight: 500, color: C.textBody };

  return (
    <div
      className={classes.card}
      style={{ ...cardStyle, alignItems: description ? "flex-start" : "center", opacity: disabled ? 0.72 : 1 }}
      onClick={disabled ? undefined : onSelect}
    >
      <div className={classes.radio} style={radioStyle}>
        {checked ? <div className={classes.radioDot} /> : null}
      </div>
      <div>
        <p className={classes.title} style={titleStyle}>
          {title}
        </p>
        {description ? <p className={classes.description}>{description}</p> : null}
      </div>
    </div>
  );
};

export const RBPayChoiceGroup: React.FC<{
  children: React.ReactNode;
  errorMessage?: string;
}> = ({ children, errorMessage }) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.group}>{children}</div>
      {errorMessage ? <div className={classes.errorText}>{errorMessage}</div> : null}
    </div>
  );
};
